import React, { Component } from 'react';
import { Card, CardBody, Row, Col } from "reactstrap";

//Import Charts
import ReactApexChart from 'react-apexcharts';
import "./dashboard.scss";

class TestimonyPercentage extends Component {
    constructor(props) {
        super(props);
        this.state= {
            series: this.props.statsdata.length > 0 ? [this.props.statsdata[2].value, this.props.statsdata[1].value] : [ 0, 0],
            options : {
                labels: ["Male", "Female"],
                plotOptions: {
                    pie: {
                        donut: {
                            size: '60%'
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false,
                },
                colors: ['#5664d2', '#1cbb8c'],
            
            }
        }
    }
    render() {
        return (
            <React.Fragment>
                {this.props.statsdata && this.props.statsdata.length > 0 ?
                                <Card>
                                    <CardBody>
                                        <div className="float-right">
                                            <select className="custom-select custom-select-sm">
                                                <option defaultValue>Testimonies</option>
                                                <option value="1">Offline testimonies</option>
                                                <option value="2">Online testimonies</option>
                                                <option value="3">Video testimonies</option>
                                            </select>
                                        </div>
                                        <h4 className="card-title mb-4">Testimony Analytics</h4>

                                        <div id="donut-chart" className="apex-charts">
                                        <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height="230" />
                                        </div>

                                        <Row>
                                            <Col xs={6}>
                                                <div className="text-center mt-4">
                                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-primary font-size-10 mr-1"></i> Male</p>
                                                    <h5>{Math.round(this.props.statsdata[2].value/((this.props.statsdata[2].value+this.props.statsdata[1].value)/100))} %</h5>
                                                </div>
                                            </Col>
                                            <Col xs={6}>
                                                <div className="text-center mt-4">
                                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-success font-size-10 mr-1"></i> Female</p>
                                                    <h5>{Math.round(this.props.statsdata[1].value/((this.props.statsdata[2].value+this.props.statsdata[1].value)/100))} %</h5>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                :
                                ""
                    }
            </React.Fragment>
        );
    }
}

export default TestimonyPercentage;